<div class="row" *ngIf="typeOfCompany == 'Company' && isUserSuperUserOr4dot5Admin">
    <div class="col-xs-12">
        <div class="main-box">
            <div class="main-box-body clearfix">
                <br />
                <h2 style="color: #03a9f4;"><b>Reports</b></h2>
                <br />
                <div class="col-xs-11 col-sm-10">
                    <table width="100%">
                        <tr>
                            <td width="23%">
                                <label for="companyBranding" class="control-label">Company Branding:
                                </label>
                            </td>
                            <td width="30%" colspan="5">
                                <div class="comp-management-radio" style="display: inline">
                                    <input type="radio" name="companyBranding" id="companyBrandingYes"
                                        [value]="true" (change)="onEnableBrandingChange()"
                                        [(ngModel)]="preferences.enableCompanyBranding">
                                    <label for="companyBrandingYes">
                                        Yes
                                    </label>
                                </div>
                                <div class="comp-management-radio" style="display: inline;">
                                    <input type="radio" name="companyBranding" id="companyBrandingNo"
                                        [value]="false" (change)="onEnableBrandingChange()"
                                        [(ngModel)]="preferences.enableCompanyBranding">
                                    <label for="companyBrandingNo">
                                        No
                                    </label>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr *ngIf="preferences.enableCompanyBranding" class="company-branding-block">
                            <td width="23%">
                                <label for="companyLogoUpload" class="control-label">Please upload a high
                                    resolution file of size 1040 x 340 to display
                                    logo on main reporting page.
                                </label>
                            </td>
                            <td width="20%" colspan="2" class="text-center">
                                <img src="assets/app-content/img/company.png"
                                    *ngIf="preferences.frontPageLogoS3Url == null"
                                    alt="Image not found"
                                    class="profile-img img-responsive center-block" />
                                <p class="text-danger"
                                    *ngIf="headerLogo !== undefined && preferences.frontPageLogoS3Url == savedAssessmentWorkFlow.frontPageLogoS3Url">
                                    Not Uploaded</p>
                                <img
                                    *ngIf="preferences.frontPageLogoS3Url !== null"
                                    [src]="preferences.frontPageLogoS3Url" alt="Image not found"
                                    class="profile-img img-responsive center-block" />
                                <div id="headerLogoPreview" [innerHTML]="headerLogoPreviewError"></div>
                                <div class="profile-label text-center">
                                    <input id="headerLogo" type="file" accept="image/*"
                                        (change)="onHeaderLogoFileSelected($event)" />
                                    <label for="headerLogo" class="custom-file-upload" id="select-company-logo">
                                        <span>Select Company Logo</span>
                                    </label>
                                </div>
                                <button class="btn btn-primary" style="width:175px"
                                    *ngIf="headerLogo !== undefined" (click)="uploadCompanyLogo(false)"
                                    [disabled]="uploadCompanyHeaderLogoInProgress">
                                    <i class="fa fa-upload mr-2"></i>
                                    <span *ngIf="!uploadCompanyHeaderLogoInProgress">Upload Logo</span>
                                    <span *ngIf="uploadCompanyHeaderLogoInProgress">Uploading Logo..</span>
                                </button>
                            </td>
                            <td></td>
                        </tr>
                        <tr *ngIf="preferences.enableCompanyBranding" class="company-branding-block">
                            <td width="23%" style="padding-top: 27px;">
                                <label for="smallLogo" class="control-label">Do you
                                    want a small logo on the right hand side of
                                    every page?
                                </label>
                            </td>
                            <td width="30%" colspan="5">
                                <div class="comp-management-radio" style="display: inline">
                                    <input type="radio" name="smallLogo" id="smallLogoYes" [value]="true"
                                        (change)="onEnableSmallLogo()"
                                        [(ngModel)]="preferences.addSmallHeaderToReport">
                                    <label for="smallLogoYes">
                                        Yes
                                    </label>
                                </div>
                                <div class="comp-management-radio" style="display: inline;">
                                    <input type="radio" name="smallLogo" id="smallLogoNo" [value]="false"
                                        (change)="onEnableSmallLogo()"
                                        [(ngModel)]="preferences.addSmallHeaderToReport">
                                    <label for="smallLogoNo">
                                        No
                                    </label>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr *ngIf="preferences.enableCompanyBranding && preferences.addSmallHeaderToReport"
                            class="company-branding-block">
                            <td width="23%">
                                <label for="smallLogoUpload" class="control-label">Please upload a high
                                    resolution file of size 160 x 50.
                                </label>
                            </td>
                            <td width="20%" colspan="2" class="text-center">
                                <img src="assets/app-content/img/company.png"
                                    *ngIf="preferences.smallHeaderLogoS3Url == null"
                                    alt="Image not found"
                                    class="profile-img img-responsive center-block" />
                                <p class="text-danger"
                                    *ngIf="smallHeaderLogo !== undefined && preferences.smallHeaderLogoS3Url == savedAssessmentWorkFlow.smallHeaderLogoS3Url">
                                    Not Uploaded</p>
                                <img
                                    *ngIf="preferences.smallHeaderLogoS3Url !== null"
                                    [src]="preferences.smallHeaderLogoS3Url" alt="Image not found"
                                    class="profile-img img-responsive center-block" />
                                <div id="smallHeaderLogoPreview" [innerHTML]="smallHeaderLogoPreviewError"></div>
                                <div class="profile-label text-center">
                                    <input id="smallHeaderLogo" type="file" accept="image/*"
                                        (change)="onSmallHeaderLogoFileSelected($event)" />
                                    <label for="smallHeaderLogo" class="custom-file-upload"
                                        id="select-company-small-logo">
                                        <span>Select Smaller Logo</span>
                                    </label>
                                </div>
                                <button class="btn btn-primary" style="width:175px"
                                    *ngIf="smallHeaderLogo !== undefined" (click)="uploadCompanyLogo(true)"
                                    [disabled]="uploadCompanyHeaderLogoInProgress || uploadCompanySmallHeaderLogoInProgress">
                                    <i class="fa fa-upload mr-2"></i>
                                    <span *ngIf="!uploadCompanySmallHeaderLogoInProgress">
                                        Upload Smaller Logo
                                    </span>
                                    <span *ngIf="uploadCompanySmallHeaderLogoInProgress">
                                        Uploading Logo..
                                    </span>
                                </button>
                            </td>
                            <td></td>
                        </tr>
                        <tr *ngIf="preferences.enableCompanyBranding">
                            <td width="23%">
                                <label for="companyBranding" class="control-label">Select the color for all the
                                    border:
                                </label>
                            </td>
                            <td style="text-align: center; padding-top:12px" colspan="2" width="10%">
                                <input type="color" name="favcolor" value="#ff0000"
                                    [(ngModel)]="preferences.reportColor">
                            </td>
                            <td></td>
                        </tr>
                    </table>
                </div>
                <br />
            </div>
        </div>
    </div>
</div>
